export enum EnumIndIntermed {
    OP_SEM_INTERMEDIADOR = 0,
    OP_SITE_PLAT_TERCEIROS = 1,
}
